const superAdminPermission = 'super_admin'

export function hasSuperAdminPermission(accessToken: string): boolean {
  return decodeAccessTokenPermissions(accessToken).includes(superAdminPermission)
}

function decodeAccessTokenPermissions(accessToken: string): string[] {
  const claims = decodeAccessTokenClaims(accessToken)
  const permissions = claims?.permissions

  return Array.isArray(permissions) ? permissions.filter(isString) : []
}

function decodeAccessTokenClaims(accessToken: string): Record<string, unknown> | undefined {
  const [, encodedPayload] = accessToken.split('.')
  if (!encodedPayload) return undefined

  try {
    return JSON.parse(decodeBase64Url(encodedPayload))
  } catch {
    return undefined
  }
}

function decodeBase64Url(encodedPayload: string): string {
  return atob(encodedPayload.replace(/-/g, '+').replace(/_/g, '/'))
}

function isString(permission: unknown): permission is string {
  return typeof permission === 'string'
}
